import {
  ACCESS_LEVELS,
} from '@/lib/consts.js'

import Products from './products.js'
import Deliveries from './deliveries.js'
import Documents from './documents.js'
import Brands from './brands.js'
import Suppliers from './suppliers.js'
import { ROUTE_META_PARAMS } from '@/router/consts.js'
import { SESSION_STORAGE_KEYS } from '@/composables/storage/session-storage-keys.js'
import { useCore } from '@/composables/core/index.js'

export const INVENTORY_ROUTES = {
  PRODUCTS: 'inventory.products',
  STORE: 'inventory.ecommerce',
  ORDERS: 'inventory.orders',
  ORDER_DETAILS: 'inventory.orders.details',
  CREATE_SUPPLY: 'inventory.orders.create',
  STORAGE_LOCATIONS: 'inventory.storage-locations',
}

const hasEcommerceAccess = () => {
  const { store } = useCore()

  return store.getters['business/hasEcommerceEnabled']
}

const navigationMetaTagsCheck = (to) => {
  if (to.query.hideNavigation === '1') {
    sessionStorage.setItem(SESSION_STORAGE_KEYS.HIDE_NAVIGATION, '1')
  } else if (to.query.hideNavigation === '0') {
    sessionStorage.removeItem(SESSION_STORAGE_KEYS.HIDE_NAVIGATION)
  }
}

const setNavigationMetaTags = (to) => {
  const isNavigationHidden = sessionStorage.getItem(SESSION_STORAGE_KEYS.HIDE_NAVIGATION)

  if (isNavigationHidden) {
    to.meta.hideSidebar = true
    to.meta.hideTabs = true
  }
}

const inventoryRoutes = [
  {
    path: 'storage-locations',
    name: INVENTORY_ROUTES.STORAGE_LOCATIONS,
    component: () => import('@/views/business/inventory/storage-locations/index.vue'),
    meta: {
      [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.RECEPTION,
    },
  },
  Documents,
  Brands,
  Suppliers,
  ...Products,
  ...Deliveries,
]

const storeRoutes = [
  {
    path: 'ecommerce/:path(.*)?',
    name: INVENTORY_ROUTES.STORE,
    component: () => import('@/views/business/inventory/ecommerce/store/index.vue'),
  },
  {
    path: 'orders',
    name: INVENTORY_ROUTES.ORDERS,
    component: () => import('@/views/business/inventory/ecommerce/orders/index.vue'),
  },
  {
    path: 'orders/create',
    name: INVENTORY_ROUTES.CREATE_SUPPLY,
    component: () => import('@/views/business/inventory/ecommerce/orders/details.vue'),
    meta: {
      hideTabs: true,
    },
  },
  {
    path: 'orders/:documentId',
    name: INVENTORY_ROUTES.ORDER_DETAILS,
    component: () => import('@/views/business/inventory/ecommerce/orders/details.vue'),
    meta: {
      hideTabs: true,
    },
  },
]

export default {
  path: 'inventory',
  name: 'inventory',
  meta: {
    defaultSubroute: () => {
      return { name: hasEcommerceAccess() ? 'inventory.ecommerce' : 'inventory.products' }
    },
    hintKey: 'hintFeatureInventory',
  },
  beforeEnter: (to, __, next) => {
    navigationMetaTagsCheck(to)

    next()
  },
  component: () => import('@/views/business/inventory/index.vue'),
  children: [
    ...storeRoutes.map((item) => ({
      ...item,
      beforeEnter: (to, __, next) => {
        if (hasEcommerceAccess()) {
          setNavigationMetaTags(to)

          next()
        } else {
          next({ name: 'inventory.products' })
        }
      },
    })),
    ...inventoryRoutes.map((item) => ({
      ...item,
      meta: {
        [ROUTE_META_PARAMS.ACCESS_LEVEL]: ACCESS_LEVELS.RECEPTION,
      },
    })),
  ],
}
